// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bct_a bhl_b bhl_uy bhl_rt bhl_ru bhl_vs","PanelFooter--link":"bct_b"};